import { FC } from 'react';

import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';
import TableSkeleton from 'modules/_shared/components/Tables/TableSkeleton';

import { useObservationsSection } from '../context/ObservationsSectionContext';
import ObservationsSectionTable from './ObservationsSectionTable';

const ObservationsSectionBody: FC = () => {
  const { data, actions } = useObservationsSection();

  const showPagination =
    data.observations && data.observationsTotal > (data.rowsPerPage || 10);

  return (
    <div className="mt-4">
      {data.isLoadingObservations ? (
        <TableSkeleton
          rows={10}
          columns={4}
          showSubHeader={false}
          cardInner={false}
        />
      ) : (
        <ObservationsSectionTable />
      )}

      {showPagination && (
        <DataTablePagination
          className="border-0"
          itemPerPage={data.rowsPerPage || 10}
          totalItems={data.observationsTotal || 0}
          paginate={actions.handleChangePage}
          currentPage={data.page}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
          customItemPerPage={0}
          setRowsPerPage={() => {}}
        />
      )}
    </div>
  );
};
export default ObservationsSectionBody;
